module.exports = __webpack_public_path__ + "static/media/3DPPA19.61cc4b4e.jpg";